// extracted by mini-css-extract-plugin
module.exports = {"tehranto-footer":"footer_tehranto-footer__lIvDJ","links":"footer_links__AOq_Z","rights":"footer_rights___xrsR"};